import { emailFormatRule, phoneNumberFormatRule, requiredInputRule, } from "@erp/shared/utils/form/rules";
import { ESTIMATE_BASIC_INFO, } from "./EstimateWriteTab.types";
import { formatYYMMDD } from "@erp/shared/utils/date/formatted-date";
export const estimateDefaultInfo = (prefix) => [
    {
        label: ESTIMATE_BASIC_INFO.발행일,
        type: "dateSingle",
        menu: "",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: ESTIMATE_BASIC_INFO.사내견적번호,
        type: "chipSelect",
        col: "12",
        sm: "4",
        lg: "4",
        value: prefix + formatYYMMDD(),
        chipMeta: { mode: "auto" },
        chipOptions: {
            placeholder: "+ 견적번호 선택",
            autoGenerate: () => prefix + formatYYMMDD(),
            searchFn: async () => [],
            duplicateCheckFn: undefined,
            duplicateErrorMsg: "이미 존재하는 사내 견적번호입니다",
            searchHeaders: [
                { text: "사내 견적번호", value: "displayValue" },
                { text: "업체명", value: "companyName" },
                { text: "상태", value: "approvalPhase" },
            ],
        },
        rules: [requiredInputRule],
    },
    {
        label: ESTIMATE_BASIC_INFO.기업별입찰번호,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
];
export const estimateDefaultInfo2 = [
    {
        label: ESTIMATE_BASIC_INFO.납기일,
        type: "dateSingle",
        menu: "",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: ESTIMATE_BASIC_INFO.견적명,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: ESTIMATE_BASIC_INFO.견적기간,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: ESTIMATE_BASIC_INFO.특이사항,
        col: "12",
        sm: "4",
        lg: "12",
        value: "",
    },
];
export const estimateSearchCompanyInfoInputs = [
    {
        label: ESTIMATE_BASIC_INFO.업체명,
        column_name: "company_name",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: ESTIMATE_BASIC_INFO.담당자,
        column_name: "company_manager",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: ESTIMATE_BASIC_INFO.담당자이메일,
        column_name: "company_manager_email",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [requiredInputRule, emailFormatRule],
    },
    {
        label: ESTIMATE_BASIC_INFO.담당자연락처,
        column_name: "company_manager_phone",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [requiredInputRule, phoneNumberFormatRule],
    },
];
export const estimateFilesInputs = [
    {
        label: ESTIMATE_BASIC_INFO.승인서,
        column_name: "approval",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        value: null,
    },
    {
        label: ESTIMATE_BASIC_INFO.도면,
        column_name: "blueprint",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        value: null,
    },
    {
        label: ESTIMATE_BASIC_INFO.기타,
        column_name: "etcFiles",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        multiple: true,
        value: null,
    },
];
